export default {
    data() {
        return {
            socket: '', //WebSocket
            lockReconnect: false, // 是否真正建立连接
            heartbeatTimeCycle: 20 * 1000, // 定义心跳周期默认为20s
            timeoutObj:'', //心跳心跳倒计时
            serverTimeoutObj: '', //心跳倒计时
            timeoutNum:'',
        }
    },
    destroyed() {
        this.closeWebsocket()
    },
    methods: {
        initWebSocket(fn, url) {
            let weburl = url || this.webSocketUrl
            if (!window.WebSocket) { return }
            if (!this.socket) {
                this.socket = new WebSocket(weburl)
                this.socketOnOpen()
                this.socketOnClose()
                this.socketOnError()
                this.socketOnMessage(fn)
            }
        },
        /**
         * 关闭websocket
         */
        closeWebsocket() {
            if (this.socket) {
                this.socket.close()
            }
        },
        socketOnSend(data) {
            if (this.socket.readyState == 1)
                this.socket.send(data)
        },
        socketOnOpen() {
            this.socket.onopen = () => {
                console.log('连接成功!')
                // this.startHeartbeat();
            }
        },
        socketOnClose() {
            this.socket.onclose = () => {
                console.log('ws已经关闭')
            }
        },
        socketOnError() {
            this.socket.onerror = () => {
                console.log('ws连接失败')
                this.reconnect()
            }
        },
        socketOnMessage(fn) {
            this.socket.onmessage = (e) => {
                if (e.data.includes("heartbeat")) {
                    // 在心跳周期内收到后端消息, 则重置心跳
                    this.resetHeartbeat();
                } else {
                    // 把后端返回值给回调函数
                    console.log("收到来自后端的数据");
                    fn(JSON.parse(e.data))
                }
            }
        },
        // 开启心跳
        startHeartbeat() {
            this.timeoutObj && clearTimeout(this.timeoutObj);
            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
            console.log("开启心跳---心跳周期：(毫秒)", this.heartbeatTimeCycle);
            this.timeoutObj = setTimeout(() => {
                // 如果连接正常
                if (this.socket.readyState == 1) {
                    // 这里发送一个心跳，后端收到后，返回一个心跳消息
                    this.socket.send('{"heartbeat":"heartbeat"}');
                    console.log('发送心跳');
                } else {
                    // 否则重连
                    this.reconnect();
                }
                this.serverTimeoutObj = setTimeout(() => {
                    // 超时关闭
                    console.log("心跳超时未响应---", this.heartbeatTimeCycle);
                    this.socket.close();
                }, this.heartbeatTimeCycle);
            }, this.heartbeatTimeCycle);
        },
        resetHeartbeat() {
            //清除时间
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            //重启心跳
            // this.startHeartbeat();
        },
        reconnect() {
            if (this.lockReconnect) {
                return;
            }
            this.lockReconnect = true;
            //没连接上会一直重连，设置延迟避免请求过多
            this.timeoutNum && clearTimeout(this.timeoutNum);
            this.timeoutNum = setTimeout(() => {
                //新连接
                console.log('尝试重连',this.socket);
                this.initWebSocket(this.global_callback);
                this.lockReconnect = false;
            }, 5000);
        }
 
    },
}